import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import NotificationCounter from '@wix/da-ds/pkg/Indicators/NotificationCounter';
import LlamaIcon from '@wix/da-ds/pkg/Icons/Llama';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './FakeNotification.scss';
const FakeNotification = ()=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: s['notification']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['notification-icon']
    }, /*#__PURE__*/ React.createElement(LlamaIcon, {
        size: IconSize.SMALL
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['notification-content']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['notification-text']
    }, t('siteHeader.anonFakeNotifications.notification.text')), /*#__PURE__*/ React.createElement("div", {
        className: s['notification-timestamp']
    }, t('siteHeader.anonFakeNotifications.notification.timestamp')), /*#__PURE__*/ React.createElement("div", {
        className: s['notification-action']
    }, /*#__PURE__*/ React.createElement(SolidButton, {
        href: Url.joinLink(),
        variant: "approval-green",
        size: "small",
        className: s['notification-button'],
        biData: BiData({
            evid: 240,
            referral_info: ReferralType.ANON_JOIN_NOTIFICATION
        })
    }, t('siteHeader.anonFakeNotifications.notification.action')))), /*#__PURE__*/ React.createElement("div", {
        className: s['notification-counter']
    }, /*#__PURE__*/ React.createElement(NotificationCounter, null, "1")));
};
FakeNotification.displayName = 'FakeNotification';
export default FakeNotification;
